import React from "react";
import { Logo } from "./appLogoStyles.js";

const LOGO = {
  MOBILE: "/images/gcc-thd_mobile.svg",
  DESKTOP: "/images/gcc_thd_desktop.svg",
};

export const AppLogo = () => {
  const screenSize = document.documentElement.clientWidth;
  const logoInfo = screenSize <= 768 ? LOGO.MOBILE : LOGO.DESKTOP;

  return (
    <Logo src={logoInfo} alt="Global Custom commerce and Home depot logo" />
  );
};
